import * as PRICING_PAGE_PARAMS from './queryParamTrack'

import navigateToPricingPage from './navigateToPricingPage'

export default navigateToPricingPage

export {
  PRICING_PAGE_PARAMS,
}
